import { Col, Row, Tag } from 'antd';
import React, { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { LinkContextModel } from '../../../store/models/linkContextModel';
import { UploadFile } from 'antd/lib/upload/interface';
import { updateFileList } from '../../../store/actions/linkContextAction';

const FileListWithAction = ({ linkedTo }: any): ReactElement => {
  const { fileList: files = {} } = useSelector((state: RootState): LinkContextModel => state?.linkContext || {});
  const dispatch = useDispatch();
  const fileList = files[linkedTo] || [];

  const onDelete = (selectedFile: UploadFile): any => {
    const selectedIndex = fileList?.findIndex((ele: any): boolean => ele?.uid === selectedFile?.uid);
    if (selectedIndex > -1) {
      fileList?.splice(selectedIndex, 1);
      dispatch(updateFileList({ ...files, [linkedTo]: [...fileList] }));
    }
  };

  return (
    <Row className="link-context-file-list">
      {
        fileList?.map((file: any, index: number): any => (
          <Col key={file?.uid}>
            <Tag className="mb-sm custom-tag" closable={true} onClose={(): any => onDelete(file)}>
              {(file?.name || '').slice(0, 12)}
            </Tag>
          </Col>
        ))
      }
    </Row>
  );
};

export default FileListWithAction;
